import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";

const Smmservice = () => {
  return (
    <div className="sf-services">
      <h3>Our Social Media Marketing Services</h3>
      <p className="sf-description">
        As a leading <b>SEO Company in Noida</b> , we offer a wide range of SEO
        services to help your business grow online.
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Social Media Account Management</h3>
          <p>
            We manipulate your social media debts professionally, making sure
            consistent posting, target audience engagement, emblem voice
            alignment, and well timed responses to build agree with, growth
            visibility, and toughen your on line presence.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Content Creation & Strategy</h3>
          <p>
            We create engaging, high-quality content material and increase
            strategic plans tailored in your target market, helping your brand
            communicate correctly, growth engagement, and build a robust and
            constant identity.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Paid Advertising Campaigns</h3>
          <p>
            We layout and control focused paid marketing campaigns on structures
            like Facebook and Instagram, specializing in maximizing attain,
            producing pleasant leads, and reaching higher conversions within
            your price range.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>Audience Targeting & Retargeting</h3>
          <p>
            We perceive your ideal target market using facts-pushed insights and
            implement advanced focused on and retargeting strategies to attain
            potential clients, re-have interaction traffic, and enhance usual
            campaign overall performance effectively.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>Performance Tracking & Reporting</h3>
          <p>
            We reveal marketing campaign performance using advanced analytics
            gear, providing exact reports on key metrics like engagement,
            attain, and conversions, assisting you recognize consequences and
            make informed advertising decisions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Smmservice;
